import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../../TimeModal/TimeModalContext';
import { normalizeDate } from '../../../Utils/GlobalUtils';

import Loading from '../../Loading';

import FileUploadField from '../../FileUploadField';
import InputCaseSelector from '../../InputSpecialFields/InputCaseSelector';

import styles from '../../../styles/DynamicModal.module.css';

import IconContainer from '../../IconContainer';
import { ReactComponent as XIcon } from '../../../icons/x-close.svg';

const EditAdministrativeResponsibility = ({ closeModal, id, action, userId, onSuccess }) => {
    const { openTimeModal } = useTimeModal();

    const [formInfo, setFormInfo] = React.useState({
        id: '',
        user_id: '',
        court: '',
        case_number: '',
        case_id: '',
        attraction_date: '',
        measure: '',
    });
    const [status, setStatus] = React.useState('');
    const [loading, setLoading] = React.useState(true);

    

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    }
    React.useEffect(() => {
        if (action=='change') {
            const token = localStorage.getItem('token');
            if (!token) handleLogout();
            setStatus(<a><Loading type='inline' /></a>);

            axios.get(`/api/get-single-administrative-responsibility?id=${id}`)
            .then((response) => {
                setFormInfo(response.data);
                setStatus(null);
            }).catch((error) => {
                console.error(error);
                setStatus(<a className='mainLabelError'>Не удалось загрузить данные. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
            }).finally(() => {
                setLoading(false);
            })
        } else {
            setLoading(false);
        }
    }, [])

    const handleChange = (field) => (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

        setFormInfo((prev) => ({ ...prev, [field]: value }));

        setStatus('Сохраните изменения');

        setErrorsForm((prevErrors) => {
        if (!prevErrors[field]) return prevErrors;
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[field];
            return updatedErrors;
        });
    };

    const [errorsForm, setErrorsForm] = React.useState({});
        const validateForm = () => {
        const newErrors = {};
    
        if (!formInfo.court) {
            newErrors.court = 'Обязательное поле';
        }
        if (formInfo.court && (formInfo.court.length < 2 || formInfo.court.length > 150)) {
            newErrors.insurance_company_name = 'Значение не может быть меньше 2 и более 150 символов';
        }

        if (!formInfo.case_id) {
            newErrors.case = 'Выберите дело';
        }
        if (!formInfo.attraction_date) {
            newErrors.attraction_date = 'Обязательное поле';
        }
        if (!formInfo.measure) {
            newErrors.measure = 'Обязательное поле';
        }
        if (formInfo.measure && (formInfo.measure.length < 2 || formInfo.measure.length > 150)) {
            newErrors.measure = 'Значение не может быть меньше 2 и более 150 символов';
        }

        if (!files.doc) {
            newErrors.doc = 'Прикрепите файл';
        }
    
        setErrorsForm(newErrors);
        if (Object.keys(newErrors).length > 0) {
            setStatus(<a className='mainLabelError'>Данные не сохранены. Проверьте корректность введенных полей</a>);
            return false;
        } else {
            return true;
        }
    };

    const addData = () => {
        const formData = new FormData();

        formData.append('user_id', userId);
        formData.append('court', formInfo.court);
        formData.append('case_id', formInfo.case_id);
        formData.append('attraction_date', normalizeDate(formInfo.attraction_date));
        formData.append('measure', formInfo.measure);

        if (files.doc) {
        formData.append('file_doc', files.doc);
        }

        axios.put('/api/add-new-administrative-responsibility', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(() => {
            setStatus('Новые данные добавлены');
            onSuccess();
            openTimeModal('Данные успешно добавлены', 'success');
            closeModal();
        })
        .catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        })
    }

    const changeData = () => {
        axios.put(`/api/change-administrative-responsibility`, {
            id: formInfo.id,
            user_id: formInfo.user_id,
            court: formInfo.court,
            case_id: formInfo.case_id,
            attraction_date: normalizeDate(formInfo.attraction_date),
            measure: formInfo.measure,
        }).then(() => {
            setStatus('Данные изменены');
            onSuccess();
            openTimeModal('Данные успешно изменены', 'success');
            closeModal();
        }).catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        })
    }

    const handleSave = () => {
        setLoading(true);
        setStatus(<a><Loading type='inline' /></a>);

        if (validateForm()) {
            if (action=='add') addData();
            if (action=='change') changeData();
        }
        setLoading(false);
    };

    const [files, setFiles] = React.useState({
        doc: null,
    });
    const handleFileChange = (field) => (e) => {
        const file = e.target.files[0];
        setFiles((prev) => ({
            ...prev,
            [field]: file || null,
        }));
    };
    const handleFileReset = (field) => () => {
        setFiles((prev) => ({
            ...prev,
            [field]: null,
        }));
    };


    return (
        <div className={styles.liningOver}>
            <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>
                        {action=='add' && 'Добавление'}{action=='change' && 'Редактирование'}
                        &nbsp;сведений об административной ответственности
                    </h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main}>
                    <div className='labelInputWrapper'>
                        <a className='label'>Суд</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input 
                                type='text' 
                                value={formInfo.court} 
                                onChange={handleChange('court')} 
                                className={errorsForm.court ? 'inputError' : ''}
                                placeholder='Полное наименование без сокращений' 
                                minLength='' 
                                maxLength='150' 
                                disabled={loading}
                                required />
                                {errorsForm.court && <div className='errorUnderInput'>{errorsForm.court}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Номер дела</a>
                        <div className='labelInputRight'>
                            <InputCaseSelector
                                initialSearchTerm={formInfo.case_number}
                                formInfo={formInfo}
                                setFormInfo={setFormInfo}
                                errorsForm={errorsForm}
                                setErrorsForm={setErrorsForm}
                            />
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Дата привлечения</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input type='date' 
                                value={formInfo.attraction_date?.split('T')[0]}
                                onChange={handleChange('attraction_date')} 
                                className={errorsForm.attraction_date ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='' 
                                disabled={loading}
                                required />
                                {errorsForm.attraction_date && <div className='errorUnderInput'>{errorsForm.attraction_date}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Мера ответственности</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input 
                                type='text' 
                                value={formInfo.measure} 
                                onChange={handleChange('measure')} 
                                className={errorsForm.measure ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='150' 
                                disabled={loading}
                                required />
                                {errorsForm.measure && <div className='errorUnderInput'>{errorsForm.measure}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Скан документа</a>
                        <div className='labelInputRight'>
                            {action=='add' ? 
                                <div className='inputWrapper'>
                                    <FileUploadField
                                        label='Прикрепить документ'
                                        file={files.doc}
                                        buttonLabel='Прикрепить скан'
                                        onChange={handleFileChange('doc')}
                                        onReset={handleFileReset('doc')}
                                    />
                                    {errorsForm.doc && <div className='errorUnderInput'>{errorsForm.doc}</div>}
                                </div>
                            :
                                <div className='panel'>
                                    <p className='description'>Изменение файла у существующей записи невозможно</p>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className={styles.bottom}>
                    <div>{status}</div>
                    <button 
                    type='button' 
                    className='button' 
                    onClick={handleSave}
                    disabled={loading}
                    >
                        {action=='add' && 'Добавить'} 
                        {action=='change' && 'Изменить'} 
                    </button>
                </div>
            </div>
        </div>
    )
}

export default EditAdministrativeResponsibility;